import moment from "moment"
import AddressAutocompleteArtifact from "../features/frontoffice/components/inputs/AddressAutocompleteArtifact";
import PlnomocenstvoEstablishmentSignature from "../features/frontoffice/components/inputs/Plnomocenstvo/PlnomocenstvoEstablishmentSignature";
import SelectBoardMember from "../features/frontoffice/components/inputs/SelectBoardMember";
import SelectKonatel from "../features/frontoffice/components/inputs/SelectKonatel";
import SelectLikvidator from "../features/frontoffice/components/inputs/SelectLikvidator";
import SelectProkurista from "../features/frontoffice/components/inputs/SelectProkurista";
import VotingInput from "../features/frontoffice/components/inputs/VotingInput";
import Retribution from "../features/frontoffice/components/inputs/Payments/Retribution";
import Person from "../features/frontoffice/components/inputs/Person/Person";
import SelectPayment from "../features/frontoffice/components/inputs/SelectPayment";
import PropertyType from "../features/frontoffice/components/inputs/PropertyType";
import ContractPeriod from "../features/frontoffice/components/inputs/ContractPeriod";
import RegistrationCertificateArtifact from "../features/frontoffice/components/inputs/RegistrationCertificateArtifact";


export function evaluateArtifactValidity(artifactId, fieldValues, cachedFieldsAsObject, documentId) {
    let isValid = true
    if (!fieldValues[artifactId]) {
        switch (artifactId) {
            case "snippet-start": {
                break;
            }
            case "snippet-stop": {
                break;
            }
            case "PROGRAM-DATA-OBJECT": {
                break;
            }
            case "PROGRAM-BODY-DATA-OBJECT": {
                break;
            }
            case "ZAPISNICA-PODPIS-DATA-OBJECT": {
                break;
            }
            case "REPRESENTATION-DATA-OBJECT": {
                break;
            }
            case "POINT-NUMBER-DATA-OBJECT": {
                break;
            }
            default: {
                isValid = evaluateDynamicArtifactValidity(artifactId, fieldValues, cachedFieldsAsObject)
                break
            }
        }
    } else {
        isValid = evaluateDynamicArtifactValidity(artifactId, fieldValues, cachedFieldsAsObject)
    }

    return isValid;
}

function evaluateDynamicArtifactValidity(artifactId, fieldValues, cachedFieldsAsObject) {
    let isValid = true
    if (cachedFieldsAsObject[artifactId.split("-")[0]]) {
        console.log(cachedFieldsAsObject[artifactId.split("-")[0]].type)
        switch (cachedFieldsAsObject[artifactId.split("-")[0]].type) {
            case "property-type": {
                isValid = PropertyType.Validator(fieldValues, artifactId)
                break
            }
            case "address-autofill": {
                if (!cachedFieldsAsObject[artifactId.split("-")[0]].binding || cachedFieldsAsObject[artifactId.split("-")[0]].binding === "") {
                    isValid = AddressAutocompleteArtifact.Validator(fieldValues, artifactId)
                }
                break
            }
            case "konatel-select": {
                isValid = SelectKonatel.Validator(artifactId, fieldValues, cachedFieldsAsObject[artifactId.split("-")[0]].long)
                break
            }
            case "prokurista-select": {
                isValid = SelectProkurista.Validator(artifactId, fieldValues, cachedFieldsAsObject[artifactId.split("-")[0]].long)
                break
            }
            case "likvidator-select": {
                isValid = SelectLikvidator.Validator(artifactId, fieldValues, cachedFieldsAsObject[artifactId.split("-")[0]].long)
                break
            }
            case "board-member-select": {
                isValid = SelectBoardMember.Validator(artifactId, fieldValues, cachedFieldsAsObject[artifactId.split("-")[0]].long)
                break
            }
            case "property-owner-signature": {
                break
            }
            case "qrcode": {
                break
            }
            case "person-select": {
                isValid = Person.Validator(artifactId, artifactId, fieldValues, cachedFieldsAsObject[artifactId.split("-")[0]])
                break
            }
            case "contract-period": {
                isValid = ContractPeriod.Validator(fieldValues, artifactId)
                break
            }
            case "registration-certificate": {
                isValid = RegistrationCertificateArtifact.Validator(fieldValues, artifactId)
                break
            }
            case "payment": {
                isValid = SelectPayment.Validator(fieldValues, artifactId)
                break
            }
            case "retribution": {
                isValid = Retribution.Validator(fieldValues, artifactId)
                break
            }
            case "number": {
                if (!cachedFieldsAsObject[artifactId.split("-")[0]].binding || cachedFieldsAsObject[artifactId.split("-")[0]].binding === "") {
                    if (!fieldValues[artifactId] || fieldValues[artifactId] === '' || fieldValues[artifactId] === 0) {
                        isValid = false
                    }
                }
                break
            }
            default: {
                if (!cachedFieldsAsObject[artifactId.split("-")[0]].binding || cachedFieldsAsObject[artifactId.split("-")[0]].binding === "") {
                    if (!fieldValues[artifactId] || fieldValues[artifactId] === '' || (!fieldValues[artifactId].length)) {
                        isValid = false
                    }
                }
                break
            }
        }
    }
    return isValid
}

export function getInvalidFields(artifactId, fieldValues, cachedFieldsAsObject, documentId) {
    let invalidFields = []
    console.log(artifactId)
    if (!fieldValues[artifactId]) {
        switch (artifactId) {
            case "snippet-start": {
                break;
            }
            case "snippet-stop": {
                break;
            }
            case "PROGRAM-DATA-OBJECT": {
                break;
            }
            case "PROGRAM-BODY-DATA-OBJECT": {
                break;
            }
            case "ZAPISNICA-PODPIS-DATA-OBJECT": {
                break;
            }
            case "REPRESENTATION-DATA-OBJECT": {
                break;
            }
            case "POINT-NUMBER-DATA-OBJECT": {
                break;
            }
            default: {
                invalidFields = getDynamicArtifactInvalidFields(artifactId, fieldValues, cachedFieldsAsObject)
                break
            }
        }
    } else {
        invalidFields = getDynamicArtifactInvalidFields(artifactId, fieldValues, cachedFieldsAsObject)
    }

    return invalidFields;
}

function getDynamicArtifactInvalidFields(artifactId, fieldValues, cachedFieldsAsObject) {
    let invalidFields = []
    if (cachedFieldsAsObject[artifactId.split("-")[0]]) {
        switch (cachedFieldsAsObject[artifactId.split("-")[0]].type) {
            case "property-type": {
                invalidFields = PropertyType.FieldsValidator(fieldValues, artifactId)
                break
            }
            case "address-autofill": {
                if (!cachedFieldsAsObject[artifactId.split("-")[0]].binding || cachedFieldsAsObject[artifactId.split("-")[0]].binding === "") {
                    invalidFields = invalidFields.concat(AddressAutocompleteArtifact.FieldValidator(fieldValues, artifactId))
                }
                break
            }
            case "konatel-select": {
                break
            }
            case "prokurista-select": {
                break
            }
            case "likvidator-select": {
                break
            }
            case "board-member-select": {
                break
            }
            case "property-owner-signature": {
                break
            }
            case "qrcode": {
                break
            }
            case "person-select": {
                invalidFields = Person.FieldsValidator(artifactId, artifactId, fieldValues, cachedFieldsAsObject[artifactId.split("-")[0]])
                break
            }
            case "retribution": {
                invalidFields = Retribution.FieldsValidator(fieldValues, artifactId)
                break
            }
            case "contract-period": {
                invalidFields = ContractPeriod.FieldsValidator(fieldValues, artifactId)
                break
            }
            case "registration-certificate": {
                invalidFields = RegistrationCertificateArtifact.FieldsValidator(fieldValues, artifactId)
                break
            }
            case "payment": {
                invalidFields = SelectPayment.FieldsValidator(fieldValues, artifactId)
                break
            }
            default: {
                if (!cachedFieldsAsObject[artifactId.split("-")[0]].binding || cachedFieldsAsObject[artifactId.split("-")[0]].binding === "") {
                    if (!fieldValues[artifactId] || fieldValues[artifactId] === '' || (Array.isArray(fieldValues[artifactId]) && fieldValues[artifactId].length === 0)) {
                        invalidFields = [artifactId]
                    }
                }
                break
            }
        }
    }
    return invalidFields
}